import "./PPZoneHome.module.css";
import Header from "@/reusable_sections/Header";
import ZonaPP from "./sections/ZonaPP";
import Capabilities from "./sections/Capabilities";
import OrganizationalCategories from "./sections/OrganizationalCategories";
import Footer from "@/reusable_sections/Footer";
export default function PPZoneHomePage() {
  return <div>
      <Header />
      <ZonaPP />
      <Capabilities />
      <OrganizationalCategories />
      <Footer />
    </div>;
}